(() => {
  'use strict';
  const root=document.querySelector('[data-dg-lab-tool="refresh-rate"]');
  if(!root) return;
  if(root.dataset['dgLabRefreshRateInitialized'] === 'true') return;
  root.dataset['dgLabRefreshRateInitialized'] = 'true';
  const get=id=>root.querySelector('#'+id);
  const stage=get('stage');
  const orb=get('orb');
  const startButton=get('start');
  let running=false,last=0,samples=[],frames=0,raf=0;
  function median(values){ const sorted=[...values].sort((a,b)=>a-b); return sorted[Math.floor(sorted.length/2)]||0; }
  function stop(){ running=false; if(raf) cancelAnimationFrame(raf); raf=0; last=0; if(startButton) startButton.textContent='Iniciar'; }
  function loop(time){
    if(!running || document.hidden) return;
    if(last){ const delta=time-last; if(delta>2&&delta<100){ samples.push(delta); if(samples.length>240) samples.shift(); frames++; }}
    last=time;
    if(samples.length>20){ const m=median(samples), filtered=samples.filter(x=>Math.abs(x-m)<m*.2), avg=filtered.reduce((a,b)=>a+b,0)/filtered.length, hz=1000/avg, sd=Math.sqrt(filtered.reduce((s,x)=>s+(x-avg)**2,0)/filtered.length), stability=Math.max(0,100-sd/avg*400); get('hz').textContent=hz.toLocaleString('es-ES',{maximumFractionDigits:1}); get('ms').textContent=avg.toLocaleString('es-ES',{maximumFractionDigits:2}); get('stability').textContent=Math.round(stability); get('frames').textContent=frames.toLocaleString('es-ES'); }
    if(stage&&orb){ const width=stage.clientWidth+150; orb.style.transform=`translate3d(${(time/4)%width-100}px,0,0)`; }
    raf=requestAnimationFrame(loop);
  }
  function start(){ if(running) return; running=true; last=0; if(startButton) startButton.textContent='Detener'; raf=requestAnimationFrame(loop); }

  startButton?.addEventListener('click',()=>running?stop():start());
  document.addEventListener('visibilitychange',()=>{ if(document.hidden) stop(); });
  addEventListener('pagehide',stop,{once:true});
})();
